import { render, staticRenderFns } from "./capitalJournalList.vue?vue&type=template&id=4a35ccbf"
import script from "./capitalJournalList.vue?vue&type=script&lang=js"
export * from "./capitalJournalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports